import React from 'react';
import PlusComponent from "../../myComp/PlusComponent";
import ContentSettings from "../../myComp/ContentSettings";

class CodeGet extends PlusComponent {
  constructor(props) {
    super(props, "contentCode");         
  }

  render(){     
    return (
        <div>
          <ContentSettings {...this.props} controller="contentCode"></ContentSettings>
        </div>
      )
    }
}

export default CodeGet;